import {apibaseURL,eStoragebaseURL, errorMessage,LOGOUT,RESET_DOCKET_DATA,S1,S2,S3,S4} from "../../config";
import { getCookie, deleteCookie, history } from "../../services/helper/Helper";
var crypto = require('crypto');

export function encrypt(textToEncrypt) {
	var encrypt = function (plain_text, encryptionMethod, sec, iv) {
		var encryptor = crypto.createCipheriv(encryptionMethod, sec, iv);
		return encryptor.update(plain_text, 'utf8', 'base64') + encryptor.final('base64');
	};
	
	var decrypt = function (encryptedMessage, encryptionMethod, sec, iv) {
		var decryptor = crypto.createDecipheriv(encryptionMethod, sec, iv);
		return decryptor.update(encryptedMessage, 'base64', 'utf8') + decryptor.final('utf8');
	};
	
	//var textToEncrypt = new Date().toISOString().substr(0,19) + '|My super sec information.';
	var encryptionMethod = 'AES-256-CBC';
	var sec = S1+S2+S3+S4; //must be 32 char length
	var iv = sec.substr(0,16);
	
	var encryptedMessage = encrypt(textToEncrypt, encryptionMethod, sec, iv);
	var decryptedMessage = decrypt(encryptedMessage, encryptionMethod, sec, iv);

	return encryptedMessage;
}

export function decrypt(encryptedMessage) {
	var encrypt = function (plain_text, encryptionMethod, sec, iv) {
		var encryptor = crypto.createCipheriv(encryptionMethod, sec, iv);
		return encryptor.update(plain_text, 'utf8', 'base64') + encryptor.final('base64');
	};
	
	var decrypt = function (encryptedMessage, encryptionMethod, sec, iv) {
		var decryptor = crypto.createDecipheriv(encryptionMethod, sec, iv);
		return decryptor.update(encryptedMessage, 'base64', 'utf8') + decryptor.final('utf8');
	};
	
	var textToEncrypt = new Date().toISOString().substr(0,19) + '|My super sec information.';
	var encryptionMethod = 'AES-256-CBC';
	var sec = S1+S2+S3+S4; //must be 32 char length
	var iv = sec.substr(0,16);
	
	//var encryptedMessage = encrypt(textToEncrypt, encryptionMethod, sec, iv);
	var decryptedMessage = decrypt(encryptedMessage, encryptionMethod, sec, iv);
	
	return decryptedMessage;
}

export function getMydockets(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"getMydockets",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function getUniqueCaseid(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"getUniqueCaseid",
	{
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Authorization': `Bearer ${value}`
		},
	}
	)
	.then(response => response.json())
}
export function docketGeneralInfo(data) {
	let value=getCookie(btoa("TAWAJ"));
	let paramData = encrypt(JSON.stringify(data));
	return fetch(apibaseURL+"docketGeneralInfo",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: paramData
	}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		response = response.response;
		if(response != 0 || response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function getPartyInfo(data) {
	let value=getCookie(btoa("TAWAJ"));

	let paramData = encrypt(JSON.stringify(data));
	return fetch(apibaseURL+"getPartyInfo",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: paramData
	}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		response = response.response;
		if(response != 0 || response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function documentTypes() {
	let value=getCookie(btoa("TAWAJ"));
  	return fetch(apibaseURL+"getDocumentTypes",
  	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => response.json())
}
export function getDocketsList() {
	let value=getCookie(btoa("TAWAJ"));

	return  fetch(apibaseURL+"getDocketsList", {
	headers: {
		'Authorization': `Bearer ${value}`
	}
	}).then(response => response.json());

	 
//   return fetch(apibaseURL+"getDocketsList")
// 	.then(response => response.json())
}
export function externalPendingRejectedDocs(data) {
	let value=getCookie(btoa("TAWAJ"));
  	return fetch(apibaseURL+"getExternalPendingRejectedDocs",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function getUserData() {
	let value=getCookie(btoa("TAWAJ"));
  	return fetch(apibaseURL+"getUserDetails", 
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	  })
	  .then(response => {
			// You can work with 'data' here
			response = response.response;
		    if(response != 0 || response != '0') {
				response = decrypt(response);
				response = JSON.parse(response);
			}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	  })
	  .catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	  });
}
export function getCurrentUserData() {
	let value=getCookie(btoa("TAWAJ"));
  	return fetch(apibaseURL+"getUserSessionDetails", 
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		if(response.status == 401 || response.status == '401') {
			if(deleteCookie(btoa("publicAccess")) && deleteCookie(btoa("TAWAJ"))) {
			  history.push('/login');
				//   dispatch(userLogout())
				//   dispatch({type:RESET_DOCKET_DATA})
			} else {
			  //dispatch(notification(errorMessage.tryAgain))
			}

			return false;

		} else if(response.error == 'Unauthorized or session is expired') {
			if(deleteCookie(btoa("publicAccess")) && deleteCookie(btoa("TAWAJ"))) {
				history.push('/login');
			  	//   dispatch(userLogout())
			  	//   dispatch({type:RESET_DOCKET_DATA})
			}

			return false;
		}

		// Parse the JSON data from the response
		return response.json();
	  })
	  .then(response => {
			// You can work with 'data' here
			response = response.response;
		    if(response != 0 || response != '0') {
				response = decrypt(response);
				response = JSON.parse(response);
			}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	  })
	  .catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	  });
}
function userLogout() {
	return {
    type: LOGOUT
  }
}
export function caseidExists() {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"caseidExists",
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => response.json())
}
export function logoutUser() {
	return fetch(apibaseURL+"logoutUser",
	{})
	.then(response => response.json())
}
export function addUser(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"addUser",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function isUserexists(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"isUserexists",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function sendForgotPasswordLink(data) {
	return fetch(apibaseURL+"sendForgotPasswordLink",
	{method: 'POST',body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function resetOldPassword(data) {
	return fetch(apibaseURL+"resetUserPassword",
	{method: 'POST',body: data}
	)
	.then(response => response.json())
}
export function updateUserData(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"updateUserData",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function uploadDocs(data) {
//	return fetch('https://staging.osah.ga.gov/osah-public-access/uploaddocs',
	let value=getCookie(btoa("TAWAJ"));
	//let testData = encrypt(data);
	return fetch(apibaseURL+"uploadDocs",
		{
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${value}`
			},
			body: data
		}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		response = response.response;
		if(response != 0 || response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function isFileExists(data) {
	let value=getCookie(btoa("TAWAJ"));
	let testData = encrypt(data);
	//console.log(testData);
	 return fetch(apibaseURL+"isFileExists",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: testData
	}
	).then(response => response.json())
	
}
export function documentActivities() {
	let value=getCookie(btoa("TAWAJ"));
  return fetch(apibaseURL+"getDocumentsActivity",
    {
		
		headers: {
			'Authorization': `Bearer ${value}`
		}
		
	})
	.then(response => response.json())
}
export function getDocumentPreview(data) {
	let value=getCookie(btoa("TAWAJ"));
	let testData = encrypt(data);
 return fetch(apibaseURL+"documentPreview",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: testData
	}
	)
	.then(response => response.json())
}

export function updateEservicePreference(data) {
	let value=getCookie(btoa("TAWAJ"));
	return fetch(apibaseURL+"updateEservicePreference",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
